package component

import com.github.quillraven.fleks.*
import com.soywiz.korge.view.*
import org.jbox2d.dynamics.*

class CoinComponent(
    val cashType: CashTypes,
    val body: Body,
    val view: Sprite
): Component<CoinComponent> {
    var isCollected = false

    override fun type() = CoinComponent

    companion object : ComponentType<CoinComponent>()
}

enum class CashTypes {
    COIN,
    DIAMOND_1,
    DIAMOND_2,
    DIAMOND_3
}
